import Vue from 'vue'
import Vuex from 'vuex'

import ui from '@/store/ui.js'
import tags from '@/store/tags.js'
import accounts from '@/store/accounts.js'
import websites from '@/store/websites.js'
import uploads from '@/store/uploads.js'
import types from '@/store/types.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    ui,
    tags,
    accounts,
    websites,
    uploads,
    types,
  },
  strict: debug,
})
